import React from 'react';


const NoMatch = () => {
    return (
        <p>No Matching route</p>
    )
};

export default NoMatch;